const breakpoints = [0, 768, 1024, 1440];
const containerPadding = ["30px", "30px", "30px"];
const gridColumnGap = ["20px", "55px"];
const gridRowGap = ["20px", "40px"];
const mq = {
  m: `min-width: ${breakpoints[1]}px`,
  l: `min-width: ${breakpoints[2]}px`,
  xl: `min-width: ${breakpoints[3]}px`,
};
const fontFamily = '"neue-haas-grotesk-display",sans-serif';
const fontFamilyBold = '"neue-haas-grotesk-display-bold",sans-serif';
const fontFamilyMono = "supply,monospace";

const colours = {
  black: "#000000",
  grey: "#262626",
  lightGrey: "#767676",
  lightestGray: "#CBCBCB",
  purple: "#A952F5",
  white: "#ffffff",
  blue: "#1924C2",
  green: "#75FA8F",
  gold: "#D88E00",
  default: "#ffffff",
  red: "#8b0000",
  alabasterWhite: "#FAFAFA",
};

const navHeight = {
  s: "74px",
  m: "92px",
};

const theme = {
  breakpoints,
  containerPadding,
  gridColumnGap,
  gridRowGap,
  mq,
  fontFamily,
  fontFamilyBold,
  fontFamilyMono,
  colours,
  navHeight,
};

export default theme;
